import { useContext } from "react";

import {
  findByCEP,
  findByCNPJ,
} from "../../../../repository/services/BigDataService";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import {
  createCliente,
  findCliente,
} from "../../../../repositories/qerpapi/erp/prouser/v1/ClienteRepository";
import { notify } from "../../../../utils/notify";
import MaskService from "../../../../utils/mask/maskService";
import { MinClienteContext } from "../contexts/MinClienteContext";
import { EmissaoContext } from "../contexts/EmissaoContext";
import { validNotNull } from "../../../../utils/validations";
import { findUsuarios } from "../../../../repositories/qerpapi/erp/acesso/v1/UsuarioRepository";
import useEmissaoController from "./EmissaoController";

export default function useEmissaoMinClienteController() {
  const { queryParams } = useContext(QueryParamsContext);

  const { setMainLoading } = useContext(EmissaoContext);
  const { handleSelectClient } = useEmissaoController();

  const {
    //Dados Gerais
    generalWebsite,
    generalTypeSubscription,
    setGeneralTypeSubscription,
    generalCpfCnpj,
    setGeneralCpfCnpj,
    generalName,
    setGeneralName,
    generalFantasy,
    setGeneralFantasy,
    generalCep,
    setGeneralCep,
    generalAddress,
    setGeneralAddress,
    generalNumber,
    setGeneralNumber,
    generalComplement,
    setGeneralComplement,
    generalDistrict,
    setGeneralDistrict,
    setGeneralNation,
    setGeneralTelephone2,
    setGeneralTelephone3,
    setGeneralRg,
    setGeneralIe,
    setGeneralSimpleNational,
    setGeneralFinalCustomer,
    setGeneralIm,
    setGeneralCheckBudget,
    setGeneralCheckNfe,
    setGeneralCheckFinancial,
    setGeneralActive,
    setGeneralSendEmail,
    setGeneralDateInitial,
    setGeneralIeIndication,
    setGeneralWebsite,
    generalUf,
    setGeneralUf,
    generalCounty,
    setGeneralCounty,
    generalNation,
    generalTelephone1,
    setGeneralTelephone1,
    generalTelephone2,
    generalTelephone3,
    generalEmail,
    setGeneralEmail,
    generalRg,
    generalIe,
    generalSimpleNational,
    generalFinalCustomer,
    generalIm,
    generalCheckBudget,
    generalCheckNfe,
    generalCheckFinancial,
    generalActive,
    generalMatriz,
    generalSendEmail,
    generalDateInitial,
    generalIeIndication,
    setErrors,
    listUf,
    listCounty,
    loadingInputs,
  } = useContext(MinClienteContext);

  const optionsSetters = {
    general: {
      setCpfCnpj: setGeneralCpfCnpj,
      setName: (value) => setGeneralName(value()?.substring(0, 50)),
      setFantasy: (value) => setGeneralFantasy(value()?.substring(0, 50)),
      setCep: setGeneralCep,
      setAddress: (value) => setGeneralAddress(value()?.substring(0, 120)),
      setNumber: setGeneralNumber,
      setComplement: (value) => setGeneralComplement(value()?.substring(0, 60)),
      setDistrict: (value) => setGeneralDistrict(value()?.substring(0, 60)),
      setUf: setGeneralUf,
      setCounty: setGeneralCounty,
      setTelephone: setGeneralTelephone1,
      setEmail: setGeneralEmail,
    },
  };

  const clearAccordionCadastroCliente = () => {
    setGeneralName("");
    setGeneralCep("");
    setGeneralFantasy("");
    setGeneralAddress("");
    setGeneralNumber("");
    setGeneralComplement("");
    setGeneralDistrict("");
    setGeneralUf(null);
    setGeneralCounty(null);
    setGeneralNation(null);
    setGeneralTelephone1("");
    setGeneralTelephone2("");
    setGeneralTelephone3("");
    setGeneralEmail("");
    setGeneralRg("");
    setGeneralIe("");
    setGeneralSimpleNational(false);
    setGeneralFinalCustomer(true);
    setGeneralIm("");
    setGeneralCheckBudget(true);
    setGeneralCheckNfe(true);
    setGeneralCheckFinancial(true);
    setGeneralActive(true);
    setGeneralSendEmail(true);
    setGeneralDateInitial("");
    setGeneralIeIndication("");
    setGeneralWebsite("");
    setGeneralCpfCnpj("");
  };

  const handleCreateMinCliente = async (setOpen = () => {}) => {
    try {
      const hasLoading = Object.keys(loadingInputs).find(
        (key) => loadingInputs[key]
      );

      if (hasLoading)
        return notify("Aguarde todos os campos serem carregados.");

      setMainLoading(true);

      //Dados Gerais
      const resultValidation = validNotNull([
        { key: "generalCpfCnpj", value: generalCpfCnpj },
        { key: "generalName", value: generalName },
        { key: "generalFantasy", value: generalFantasy },
        { key: "generalCep", value: generalCep },
        { key: "generalAddress", value: generalAddress },
        { key: "generalDistrict", value: generalDistrict },
        { key: "generalUf", value: generalUf },
        { key: "generalCounty", value: generalCounty },
        { key: "generalNation", value: generalNation },
        { key: "generalNumber", value: generalNumber },
      ]);

      resultValidation.errorsValidation.accordions = resultValidation.error
        ? ["general"]
        : [];

      if (
        generalCpfCnpj &&
        generalTypeSubscription &&
        !MaskService.isValid(
          generalTypeSubscription.description.toLowerCase(),
          generalCpfCnpj
        )
      ) {
        resultValidation.error = true;
        resultValidation.errorsValidation.generalCpfCnpj = `${generalTypeSubscription.description} inválido`;
      }

      if (generalCep && !MaskService.isValid("cep", generalCep)) {
        resultValidation.error = true;
        resultValidation.errorsValidation.generalCep = "CEP inválido";
      }

      if (
        generalTelephone1 &&
        !MaskService.isValid("cel-phone", generalTelephone1)
      ) {
        resultValidation.error = true;
        resultValidation.errorsValidation.generalTelephone1 =
          "Telefone inválido";
      }

      if (
        generalTelephone2 &&
        !MaskService.isValid("cel-phone", generalTelephone2)
      ) {
        resultValidation.error = true;
        resultValidation.errorsValidation.generalTelephone2 =
          "Telefone inválido";
      }

      if (
        generalTelephone3 &&
        !MaskService.isValid("cel-phone", generalTelephone3)
      ) {
        resultValidation.error = true;
        resultValidation.errorsValidation.generalTelephone3 =
          "Telefone inválido";
      }

      setErrors(resultValidation.errorsValidation);
      if (resultValidation.error)
        return notify("Verifique se os campos estão preenchidos corretamente.");

      const userLogin = await findUsuarios(
        queryParams.empresa_cnpj,
        queryParams.usuario_id
      );

      if (!userLogin.success || !userLogin.data) {
        return notify(
          "Ocorreu um erro. Tente novamente com um usuário diferente."
        );
      }

      const body = {
        //Dados Gerais
        idempresa: parseInt(queryParams.empresa_id) || 6,
        quemcadastrou: userLogin.data.login || "",
        idcategoria:
          generalCpfCnpj.replace(/[^0-9]+/g, "").length === 14 ? 2 : 1,
        ativo: generalActive ? "S" : "N",
        cpfcnpj: generalCpfCnpj.replace(/[^0-9]+/g, ""),
        apelido: generalFantasy,
        razao: generalName,
        cep: generalCep.replace(/[^0-9]+/g, ""),
        endereco: `${generalAddress.trim()}${
          generalNumber ? ` , ${generalNumber.trim()}` : ""
        }`,
        complemento: generalComplement,
        bairro: generalDistrict,
        id_estado: generalUf ? generalUf.id : null,
        cidade: generalCounty ? generalCounty.municipio : null,
        municipio_codigo: generalCounty ? generalCounty.codigo : null,
        idpais: generalNation ? generalNation.codigo : null,
        ddd1: generalTelephone1.replace(/[^0-9]+/g, "").substring(0, 2),
        telefone1: generalTelephone1.replace(/[^0-9]+/g, "").substring(2),
        ddd2: generalTelephone2.replace(/[^0-9]+/g, "").substring(0, 2),
        telefone2: generalTelephone2.replace(/[^0-9]+/g, "").substring(2),
        ddd3: generalTelephone3.replace(/[^0-9]+/g, "").substring(0, 2),
        telefone3: generalTelephone3.replace(/[^0-9]+/g, "").substring(2),
        email: generalEmail,
        ie: generalIe ? generalIe.replace(/[^0-9]+/g, "") : "",
        rg: generalRg,
        simples_nacional: generalSimpleNational ? "S" : "N",
        consumidorfinal: generalFinalCustomer ? "1" : "0",
        inscricao_municipal: generalIm,
        indiedest: generalIeIndication ? generalIeIndication.codigo : null,
        enviarmailcontasvencer: generalSendEmail ? "S" : "N",
        email_utilizarorcamentovenda: generalCheckBudget ? "S" : "N",
        email_utilizarnfe: generalCheckNfe ? "S" : "N",
        email_utilizarfinanceiro: generalCheckFinancial ? "S" : "N",
        idclientematriz: generalMatriz ? generalMatriz.id : null,
        cliente_desde: generalDateInitial,
        homepage: generalWebsite,
        clientdevi: "N",
        usar_certificado_cliente: "0",
      };

      const resultSubmit = await createCliente(
        queryParams.empresa_cnpj,
        {
          cliente: body,
        },
        "municipio.estado"
      );

      if (!resultSubmit.success) {
        return notify(
          "Ocorreu um erro ao cadastrar o Cliente." + resultSubmit.msg
        );
      }

      handleSelectClient(() => {}, [resultSubmit.data]);
      setOpen(false);

      clearAccordionCadastroCliente();
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
    }
  };

  const handleChangeCpfCnpj = async (e, context) => {
    const inputValue = generalCpfCnpj.replaceAll(/[^0-9]/g, "");

    let mask,
      typeMask = inputValue;

    const setters = optionsSetters[context];

    if (inputValue.length === 14) {
      mask = "cnpj";
      typeMask = MaskService.toMask(mask, inputValue);
    } else if (inputValue.length === 11) {
      mask = "cpf";
      typeMask = MaskService.toMask(mask, inputValue);
    }

    const newNumInscricao = typeMask;
    setters.setCpfCnpj(newNumInscricao);

    if (mask === "cnpj" && newNumInscricao.length === 18) {
      setGeneralTypeSubscription({
        description: "CNPJ",
        value: "cnpj",
      });
      if (await handleFindCustomerExists(newNumInscricao, context)) return;

      await handleFindByCnpjHub(newNumInscricao, context);
    } else {
      if (await handleFindCustomerExists(newNumInscricao, context)) return;
      setGeneralTypeSubscription({
        description: "CPF",
        value: "cpf",
      });
    }
  };

  const handleFindByCnpjHub = async (cnpj, context) => {
    try {
      setMainLoading(true);

      const setters = optionsSetters[context];

      const response = await findByCNPJ(cnpj);
      const responseData = response?.data;

      if (
        response.success &&
        responseData.statusCode === 200 &&
        responseData.data
      ) {
        setters.setName(() =>
          (responseData.data.corporate_name || "").substring(0, 50)
        );
        setters.setFantasy(() =>
          (
            responseData.data.commercial_name ||
            responseData.data.corporate_name ||
            ""
          ).substring(0, 20)
        );

        let validPhone = /\b(0[0-9]{2})\b/.test(
          responseData.data.phones[0].number
        )
          ? responseData.data.phones[0].number.replace("0", "")
          : responseData.data.phones[0].number;

        setters.setTelephone(MaskService.toMask("cel-phone", validPhone || ""));
        setters.setEmail(() => responseData.data.emails[0].email || "");
        setters.setComplement(
          () => responseData.data.addresses[0].additionalInfo || ""
        );

        if (responseData.data.addresses[0].postalCode) {
          handleChangeCep(
            { target: { value: responseData.data.addresses[0].postalCode } },
            "general",
            null,
            true,
            responseData.data
          );
          setters.setNumber(() => responseData.data.addresses[0].number || "");

          return;
        }

        setters.setUf(
          listUf.find(
            (opt) => opt.estado === response.data.addresses[0].stateCode
          ) || null
        );
        const endereco = await findByCEP(response.data.addresses[0].postalCode);
        const enderecoData = endereco?.data;
        if (endereco.success && enderecoData.statusCode === 200) {
          setters.setCounty(
            listCounty.find(
              (opt) => opt.codigo === enderecoData.data.ibgeCode
            ) || null
          );
        } else {
          setters.setCounty(null);
        }
        setters.setDistrict(() => response.data.addresses[0].bairro || "");
        return;
      }

      notify(
        "Não foi possível realizar o autopreenchimento, certifique-se de que o N° de Inscrição é válido."
      );
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
    }
  };

  const handleFindCustomerExists = async (cpfCnpj, context) => {
    try {
      setMainLoading(true);

      const setters = optionsSetters[context];

      const customerExists = await findCliente({
        empresa_cnpj: queryParams.empresa_cnpj,
        where: { cpfcnpj: cpfCnpj.replace(/[^0-9]+/g, "") },
      });

      if (customerExists && customerExists.data && customerExists.data.length) {
        setters.setCpfCnpj("");
        notify("Já existe um cliente com este Nº de inscrição.");
        return true;
      }

      return false;
    } catch (error) {
      notify("Não foi possível verificar se este cliente já existe.");
      console.error(error);
      return true;
    } finally {
      setMainLoading(false);
    }
  };

  const handleChangeCep = (
    e,
    context,
    settersProp,
    byOtherFunction = false,
    responseObj = null
  ) => {
    const setters = settersProp || optionsSetters[context];

    setters.setCep(MaskService.toMask("cep", e.target.value));

    if (e.target.value.length === 10) {
      document.activeElement.blur();
      handleFindByCepHub(
        e.target.value,
        context,
        settersProp,
        byOtherFunction,
        responseObj
      );
    }
  };

  const handleFindByCepHub = async (
    cep,
    context,
    settersProp,
    byOtherFunction = false,
    responseObj = null
  ) => {
    try {
      setMainLoading(true);
      const setters = settersProp || optionsSetters[context];

      const response = await findByCEP(cep);
      const responseData = response?.data;

      if (response.success && responseData.statusCode && responseData.data) {
        setters.setUf(
          (current) =>
            listUf.find((opt) => opt.estado === responseData.data.stateCode) ||
            current
        );
        setters.setAddress(
          (current) =>
            responseObj?.logradouro || responseData.data.street || current
        );
        setters.setDistrict(
          (current) =>
            responseObj?.bairro || responseData.data.neighborhood || current
        );
        setters.setComplement(
          (current) =>
            responseObj?.complemento ||
            responseData.data.additionalInfo ||
            current
        );
        setters.setCounty(
          (current) =>
            listCounty.find(
              (opt) => opt.codigo === responseData.data.ibgeCode
            ) || current
        );
        return;
      }
      if (byOtherFunction) return;

      notify("CEP não encontrado.");
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
    }
  };

  const handleChangeUf = (e, setUfParam, setCountyParam) => {
    setUfParam(e);
    setCountyParam(null);
  };

  return {
    handleChangeCpfCnpj,
    handleChangeCep,
    handleChangeUf,
    handleCreateMinCliente,
    clearAccordionCadastroCliente,
  };
}
